/* Folicare rollback 2026-06-08: remove experimental Subscribe & Save PDP widget. */
$(document).ready(function(){

    $(".product-video-thumb-icon").click(function () {
      $(this).closest('.product-video').find("video")[0].play();
      $(this).closest('.product-video').find(".product-video-thumb").hide();
    });
    
    $(".product-video video").on('click', function () {
      $(this).closest('.product-video').find("video")[0].pause();
      $(this).closest('.product-video').find(".product-video-thumb").show();
    });
    
    
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('.customer-review-block').slick({
        dots: true,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
}

$('.hair-transformation-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true
});

});

(function folicareAmazonReviewProof() {
  var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
  if (!match) return;

  var proofByHandle = {
    'hair-thickening-shampoo': { rating: '4.8', count: '54' },
    'hair-thickening-conditioner': { rating: '4.8', count: '54' },
    'hair-growth-bundle-shampoo-conditioner': { rating: '4.8', count: '54' },
    'thickening-hair-serum': { rating: '4.8', count: '64' },
    'hair-skin-nails-vitamins': { rating: '4.8', count: '60' }
  };

  var proof = proofByHandle[match[1]];
  if (!proof) return;

  function install() {
    if (!document.getElementById('folicare-review-proof-style')) {
      var style = document.createElement('style');
      style.id = 'folicare-review-proof-style';
      style.textContent = [
        '.jdgm-preview-badge,',
        '.jdgm-review-widget,',
        '.jdgm-rev-widg,',
        '[id*="judge_me_reviews_review_widget"] { display: none !important; }',
        '.product__amazon-proof { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 8px; margin: 8px 0 2px; color: #251b17; text-decoration: none; font-size: 14px; line-height: 1.35; }',
        '.product__amazon-proof-stars { color: #d2a933; letter-spacing: 0; font-size: 15px; line-height: 1; }',
        '.product__amazon-proof strong { font-weight: 700; }',
        '.product__amazon-proof span:last-child { color: #5d5550; }',
        '.product__amazon-proof:hover span:last-child { color: #390d76; }'
      ].join('');
      document.head.appendChild(style);
    }

    var badge = document.querySelector('.product__amazon-proof');
    var title = document.querySelector('.product__title');

    if (!badge) {
      if (!title) return;
      badge = document.createElement('a');
      badge.className = 'product__amazon-proof';
      title.insertAdjacentElement('afterend', badge);
    }

    badge.href = '#fr-title';
    badge.setAttribute('aria-label', proof.rating + ' star Amazon rating from ' + proof.count + ' Amazon Verified reviews');
    badge.innerHTML =
      '<span class="product__amazon-proof-stars" aria-hidden="true">&#9733;</span>' +
      '<strong>' + proof.rating + '</strong>' +
      '<span>' + proof.count + ' Amazon Verified reviews</span>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
